import { FC } from 'react';

import { MpParagraph } from 'shared/ui/MpParagraph';

export const TgBotInstructions: FC = () => (
	<MpParagraph>
		Минимальный набор отчетов о выручке, балансе эффективности и опазданиях для технического ознакомления с
		функционалом приложения
	</MpParagraph>
);
